// the meta tag is only present in test, as we do not want to leak the environment in production settings
const isTesting = () => document.querySelector('meta[name="testing"]')

export default isTesting
